import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className="fixed bottom-0 left-0 w-full bg-gradient-to-r from-green-600 to-green-700 border-t border-green-500/20 py-4 shadow-lg z-20">
      <div className="px-6 flex flex-col md:flex-row items-center justify-between text-white/90 text-sm">
        {/* Center Copy */}
        <p className="text-center md:text-left">
          © 2025{" "}
          <a
            href="/"
            className="text-white font-semibold hover:text-green-200 transition-colors"
          >
            Whatbox
          </a>{" "}
          — All Rights Reserved.
        </p>

        {/* Right */}
        <p className="md:mr-10 text-center md:text-right mt-3 md:mt-0">
          Powered by{" "}
          <a
            href="https://zaynosoft.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white font-semibold hover:text-green-200 transition-colors"
          >
            ZaynoSoft
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
